export default Object.freeze({
	Error: 1,
	NotarizationDeleted: 2,
	ReadyForPayment: 3,
	NotarizationReset: 4
});